import { render, staticRenderFns } from "./card-footer.vue?vue&type=template&id=25b24b94&scoped=true&"
import script from "./card-footer.vue?vue&type=script&lang=js&"
export * from "./card-footer.vue?vue&type=script&lang=js&"
import style0 from "./card-footer.vue?vue&type=style&index=0&id=25b24b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b24b94",
  null
  
)

export default component.exports